import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { selectors as authSelectors } from 'src/features/auth/authSlice';
import { configVars } from 'src/helpers';
import { useFeatureFlag } from 'src/hooks/useFeatureFlag/useFeatureFlag';
import { FeatureFlagKey } from 'src/ts/enums';

const PUBLIC_PATHS = [
  '/login',
  '/logout',
  '/sessionExpired',
  '/invitation',
  '/terms',
  '/partner-terms',
  '/privacy-policy',
  '/application/apply'
];

const SalesforceChatbot: React.FC = () => {
  const { pathname } = useLocation();
  const userData = useSelector(authSelectors.user);
  const isSalesforceEnabled = useFeatureFlag(FeatureFlagKey.SALESFORCE_EMBEDDED_MESSAGING);

  const isPublicRoute = PUBLIC_PATHS.some((path) => pathname.startsWith(path));
  const showChatbot = isSalesforceEnabled && !!userData && !isPublicRoute;

  useEffect(() => {
    if (!showChatbot || !configVars.salesforce) return;

    const { siteUrl, scrt2Url, orgId, eswConfigDevName } = configVars.salesforce;
    const scriptSrc = `${siteUrl}/assets/js/bootstrap.min.js`;

    if (document.querySelector(`script[src="${scriptSrc}"]`)) return;

    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = scriptSrc;
    script.onload = () => {
      try {
        window.embeddedservice_bootstrap.settings.language = 'en_US';
        window.embeddedservice_bootstrap.init(orgId, eswConfigDevName, siteUrl, {
          scrt2URL: scrt2Url
        });
      } catch (err) {
        console.error('Error loading Embedded Messaging: ', err);
      }
    };
    document.body.appendChild(script);
  }, [showChatbot]);

  return null;
};

export default SalesforceChatbot;
